import React from "react";
import { ScrollView } from "react-native";

import {
    ScheduleTimeType,
    TimeMode,
    WorkingTimeSpecificType,
} from "../../../__generated__/graphql";
import SpecificDatesComponent from "../../../components/working_time/SpecificDatesComponent";
import VStack from "../../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = () => {
    const [workingTime, setWorkingTime] = React.useState<WorkingTimeSpecificType>({
        dates: [
            {
                date: "2022-01-01",
                daySchedule: {
                    timeMode: TimeMode.Fixed,
                    fixedTimes: [
                        { startTime: 9 * 60, endTime: 12 * 60, type: ScheduleTimeType.Work },
                        { startTime: 14 * 60, endTime: 17 * 60, type: ScheduleTimeType.Work },
                    ],
                },
            },
            {
                date: "2022-01-02",
                daySchedule: {
                    timeMode: TimeMode.Fixed,
                    fixedTimes: [
                        { startTime: 9 * 60, endTime: 12 * 60, type: ScheduleTimeType.Work },
                        { startTime: 14 * 60, endTime: 17 * 60, type: ScheduleTimeType.Work },
                    ],
                },
            },
        ],
    });

    return (
        <ScrollView style={{ width: "100%", flex: 1 }}>
            <VStack v={1}>
                <SpecificDatesComponent workingTime={workingTime} onChange={setWorkingTime} />
            </VStack>
        </ScrollView>
    );
};

const meta = {
    title: "Screens/Working time",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Specific: Story = {};
